
const React = require('react');
const Availability = require('./availability.jsx').Availability;
const Marketing = require('./marketing.jsx').Marketing;
const HeaderDetailsView = require('./header.details.jsx').HeaderDetailsView;

if (process.env.BROWSER)
    require('../scss/main.scss');

const App = React.createClass({
    render: function() {
        let data = this.state ? this.state : this.props;
        return (
            <div className="wrapper">
                <header className="layout-header">
                    <HeaderDetailsView {...data} />
                </header>
                <Availability {...data} />
                <Marketing />
            </div>
        )
    }
});

exports.App = App;